import type { PromoTextWithIcon } from '@/helpers/provider-promotion';

import { useTitleDetailsStore } from '@/helpers/composables/useStores';
import { useExperiment } from '@/libraries/experiment';
import { computed } from 'vue';

const disneyplusLandingPage = 'https://www.disneyplus.com?sub_source_id=Sept_Promo_MLP';

export function useDisneyPromotionLPExperiment() {
	const { activeVariantWithControlGroup } = useExperiment('DISNEY_PROMOTION_LP', 'global');
	const { providerPromotion } = useTitleDetailsStore();

	const activateDisneyPromotionLPExp = computed(() => isApplicablePromotion(providerPromotion.value));

	function setDisneyPromotionUrl(promo: PromoTextWithIcon): PromoTextWithIcon {
		if (activeVariantWithControlGroup.value === 'variant_1' && isApplicablePromotion(promo)) {
			promo.url = disneyplusLandingPage;
		}

		return promo;
	}

	return {
		activateDisneyPromotionLPExp,
		setDisneyPromotionUrl,
	};
}

const startDate = '2025-09-11';
const endDate = '2025-09-28';
const provider = 'dnp';

function isApplicablePromotion(promo?: PromoTextWithIcon) {
	return promo != null && promo.startDate === startDate && promo.endDate === endDate && promo.provider === provider;
}
